import Button from './src/button.vue';
import { SFCWithInstall } from '@touchvue/utils';
export declare const ToButton: SFCWithInstall<typeof Button>;
export default ToButton;
export * from './src/instance';
export type { ButtonInstance } from './src/instance';
